import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import IndexLayout from 'layouts/IndexLayout';
import MainLayout from 'layouts/MainLayout';
import AuthRoutes from 'components/AuthRoutes';
import LoginPage from 'pages/index/LoginPage';
import IndexPages from './pages/index';
import ErrorPages from './pages/errors';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'assets/styles/layout.scss';
import PrivateRoute from 'components/routers/PrivateRoute';
import { getComponentByName, routeComponentMap } from 'components/routers/routesMap';
import Pedidos from 'pages/pedidos/List';
import Funcionarios from 'pages/funcionarios/List';
import GHE from 'pages/grupogestor/GHE';
import { Home } from 'lucide-react';

const App = () => {
	const auth = useAuth();
	const [empid, setempid] = useState(null);


	function DefaultPage() {
		if (!auth.isLoggedIn) {
			return <LoginPage />
		}
		return <Navigate to="/funcionarios" replace />;
	}
	return (
		<Routes>
			<Route exact element={<AuthRoutes />}>
				<Route element={<MainLayout />}>
					<Route path="/home" element={<Home />} />
					{auth.userPages.map(({ router, component }) => {
						const _component = getComponentByName(component);
						if (!_component) 
							return null;
						return (
							<Route
								key={router}
								path={router}
								element={
									<PrivateRoute allowedRoutes={auth.userPages.map(r => r.router)}>
										<_component />
									</PrivateRoute>
								}
							/>
						);
					})}
				</Route>

			</Route>

			<Route exact element={<IndexLayout />}>
				<Route path="/" element={<DefaultPage />} />
				<Route path="/*" element={<IndexPages />} />
				<Route path="/error/*" element={<ErrorPages />} />
			</Route>
		</Routes>
	);
}
export default App;
